<h5 class="font-bold mt-4">{{'#PORTAL_REGISTRATION_ADMIN.CAPTION' | translate}}</h5>
@if (registrationCandidate$ | async; as registrationCandidate) {
  <div class="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-1 mt-2">
    <label class="soft-label soft-label-left">{{'#PORTAL_REGISTRATION_ADMIN.EMAIL' | translate}}</label>
    <span>{{registrationCandidate?.email}}</span>
    <label class="soft-label soft-label-left">{{'#PORTAL_REGISTRATION_ADMIN.NAME' | translate}}</label>
    <span>{{registrationCandidate?.firstName}} {{registrationCandidate?.lastName}}</span>
    <label class="soft-label soft-label-left">{{'#PORTAL_REGISTRATION_ADMIN.CUSTOMER_DESCRIPTION' | translate}}</label>
    <span>{{registrationCandidate?.company}}</span>
  </div>
  <h5 class="font-bold mt-5">{{'#PORTAL_REGISTRATION_ADMIN.ASSIGNED_CUSTOMERS' | translate}}</h5>
  <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="mb-4">
    <input type="hidden" formControlName="username">
    @for (info of informationFormArray.controls; track info; let i = $index) {
      <div formArrayName="information">
        <form [formGroupName]="i">
          <div class="flex flex-col mt-2">
            <label class="soft-label soft-label-top required mb-1">{{'#PORTAL_REGISTRATION_ADMIN.CUSTOMER' | translate}}</label>
            <soft-field-ok
              fieldOkName="ktostamm.kunde"
              placeholder="Kunde auswählen"
              formControlName="account"
              (valueChange)="onCustomerValueChange($event, registrationCandidate)"
              #convertValue>
            </soft-field-ok>
          </div>
          <div class="flex flex-col mt-4">
            <label class="soft-label soft-label-top mb-1">{{'#PORTAL_REGISTRATION_ADMIN.CONTACT' | translate}}</label>
            <soft-radio-group formControlName="contact">
              <div class="flex flex-col">
                <div class="flex flex-row">
                  <soft-radio-option [value]="null">
                    <span  class="soft-label soft-label-right">{{'#PORTAL_REGISTRATION_ADMIN.CONTACT_INPUT.CREATE_CONTACT' | translate}}</span>
                  </soft-radio-option>
                </div>
                @for (contact of contacts$ | async; track contact) {
                  <soft-radio-option [value]="contact">
                    <span class="soft-label soft-label-right">{{contact.firstName}} {{contact.lastName}} ({{contact.email1}}@if (contact.email2) {
                      | {{contact.email2}}
                    })</span>
                  </soft-radio-option>
                }
              </div>
            </soft-radio-group>
          </div>
          @if (informationFormArray.length > 1) {
            <div class="flex flex-row justify-end">
              <a class="soft-link" (click)="removeInformation(i)">{{'#PORTAL_REGISTRATION_ADMIN.REMOVE_CUSTOMER' | translate}}</a>
            </div>
          }
        </form>
      </div>
    }
    <div class="mt-2 mb-2">
      <a class="soft-link" (click)="addInformation()">{{'#PORTAL_REGISTRATION_ADMIN.ADD_CUSTOMER' | translate}}</a>
    </div>
    <hr />
    <div class="flex flex-row items-center mt-4">
      <soft-checkbox [trueValue]="['TICKET.KTOSTAMM']" [falseValue]="null" formControlName="permissions"></soft-checkbox>
      <span class="soft-label soft-label-right">{{'#PORTAL_REGISTRATION_ADMIN.PERMISSIONS' | translate}}</span>
    </div>
    <button type="submit" class="soft-button soft-button-primary mt-4" >{{'#PORTAL_REGISTRATION_ADMIN.SUBMIT' | translate}}</button>
  </form>
}
